export const getNodeName = (key, defaultName = 'Node') => {
  if (typeof key === 'string') {
    return key;
  }
  return key?.['#text'] || defaultName;
};
